import { createAsyncThunk } from '@reduxjs/toolkit';
import { CreateNoticeDTO } from '../Domain/Repositories/NoticeRepository';
import { NoticeRepositoryImpl } from '../Data/Repositories/NoticeRepositoryImpl';
import { GetNoticesUseCase } from '../Domain/UseCase/GetNoticesUseCase';
import { CreateNoticeUseCase } from '../Domain/UseCase/CreateNoticeUseCase';
import { UpdateNoticeUseCase } from '../Domain/UseCase/UpdateNoticeUseCase';
import { DeleteNoticeUseCase } from '../Domain/UseCase/DeleteNoticeUseCase';
import { GetNoticeUseCase } from '../Domain/UseCase/GetNoticeUseCase';

const repo = new NoticeRepositoryImpl();

export const fetchNotices = createAsyncThunk('notice/fetchAll', () =>
  new GetNoticesUseCase(repo).execute(),
);

export const addNotice = createAsyncThunk('notice/create', (dto: CreateNoticeDTO) =>
  new CreateNoticeUseCase(repo).execute(dto),
);

export const editNotice = createAsyncThunk(
  'notice/update',
  (p: { id: number; dto: Partial<CreateNoticeDTO> }) =>
    new UpdateNoticeUseCase(repo).execute(p.id, p.dto),
);

export const removeNotice = createAsyncThunk('notice/delete', (id: number) =>
  new DeleteNoticeUseCase(repo).execute(id),
);

export const fetchNoticeDetail = createAsyncThunk('notice/detail', (id: number) =>
  new GetNoticeUseCase(repo).execute(id),
);
